import React from 'react'
import { Container } from './styled'

type Props = {
  children: React.ReactNode
  background: string
  color: string
  border: string
  onclick: () => void
}

export const ActionCardContent = ({
  children,
  background,
  border,
  color,
  onclick,
}: Props) => {
  return (
    <Container
      onClick={onclick}
      background={background}
      border={border}
      color={color}
    >
      {children}
    </Container>
  )
}
